<template>
	<el-dialog :visible.sync="visible" width="30%" :before-close="handleClose">
		<div class="description layout-row layout-hv-center">註冊成功，請重新登入</div>
		<div slot="footer" class="dialog-footer layout-row layout-hv-center">
			<div class="success-button button-tp color-white bg-green1" @click="handleClose">確定</div>
		</div>
	</el-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
	props: ["visible"],
	data() {
		return {};
	},
	computed: {},
	methods: {
		...mapActions(["logout"]),
		handleClose() {
			this.$emit("close");
			this.logout();
		}
	},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.description {
	font-size: 18px;
}

.success-button {
	width: 150px;
	height: 30px;
}
</style>